import { hasRuntimeConfig, getRuntimePartner } from '@/config/runtime';
import { getPartnerBySlug } from '@/api/partners/getPartnerBySlug';
import type { IPartner } from '@/types';

const APPLIED_DOMAIN = import.meta.env.VITE_APPLIED_DOMAIN || '';

export function extractPartnerName(url: string) {
  if (import.meta.env.VITE_DEV_PARTNER) {
    return import.meta.env.VITE_DEV_PARTNER as string;
  }

  if (!APPLIED_DOMAIN) return '';

  const hostname = new URL(url).hostname;

  if (hostname.endsWith(APPLIED_DOMAIN)) {
    const index = hostname.lastIndexOf(APPLIED_DOMAIN);

    const subdomain = hostname.substring(0, index - 1); // -1 to remove the trailing dot

    const parts = subdomain.split('.');
    return parts.length > 0 ? parts[parts.length - 1] : '';
  }

  return '';
}

export function currentPartnerQuery(url: string) {
  const slug = extractPartnerName(url);

  return {
    queryKey: ['current-partner', slug],
    queryFn: async () => {
      if (hasRuntimeConfig()) {
        return getRuntimePartner();
      }

      if (!slug) {
        return null;
      }

      const {
        data: { data: partnerData },
      } = await getPartnerBySlug(slug);
      if (!partnerData) {
        return null;
      }

      const partner: IPartner = {
        ...partnerData,
        AllowWhiteLabel: '0',
        LogoFile: null,
        PrimaryColor: null,
        SecondaryColor: null,
        TertiaryColor: null,
        PrimaryTextColor: null,
        SecondaryTextColor: null,
        StoreUrl: null,
        StorePhone: null,
        StoreEmail: null,
        MarketplaceName: null,
        MarketplaceDesc: null,
        TermsOfService: null,
        PrivacyPolicy: null,
      };
      return partner;
    },
    staleTime: Number.POSITIVE_INFINITY,
  };
}
